import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RequirementService } from 'src/app/services/requirement.service';
import {NgbDateStruct, NgbCalendar, NgbDate,  NgbDatepickerConfig, NgbDatepickerI18n, NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import { DateformatService } from '../../../util/dateformat.service';
import { I18n, CustomDatepickerI18n } from 'src/app/util/ngbd-datepicker-i18n/ngbd-datepicker-i18n.component';
import { Subject, throwError } from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { Alert } from '../../model/alert.model';
@Component({
    selector: 'app-edit-alert',
    templateUrl: './edit-alert.component.html',
    styleUrls: ['./edit-alert.component.scss'],
    providers: [
        I18n,
        { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n },
        { provide: NgbDateParserFormatter, useClass: DateformatService }
    ],
    standalone: false
})
export class EditAlertComponent implements OnInit {
	@Output() confirmAlert = new EventEmitter<boolean>();
	@Input() idAlert: number;
	@Input() idActivity: number;
	@Input() reqId: number;
	// message
	errorMessageNewAlert: string = '';
	successMessageNewAlert: string = '';
	private _successNewAlert = new Subject<string>();
	private _errorNewAlert = new Subject<string>();
	model1: NgbDateStruct = null;
	mindate = undefined;
	meridian = true;
	maxdate = {};
	dateActv: string;
	timeAlert = null;
	alertName: string = '';
	actvName: string = '';
	editAlert: Alert = new Alert();
	loading: boolean = false;
  constructor(
		public activeModal: NgbActiveModal,
		public _requirements: RequirementService,
	) { }

  ngOnInit() {
		const current = new Date();
		this.mindate = {
			year: current.getFullYear(),
			month: current.getMonth() + 1,
			day: current.getDate()
		};
		this.loadAlerts();
		this.messageNewAlert();
	}
	submitForm() {
		const result = this.validationAlert();
		if (result) {
			this.loading = true;
			const dateAlert = this.model1.year + '-' + this.model1.month + '-' + this.model1.day;
			const timeAlert = this.timeAlert.hour + ':' + this.timeAlert.minute + ':' + this.timeAlert.second;
			this.editAlert.name = this.alertName;
			this.editAlert.before_activity_date = dateAlert;
			this.editAlert.before_activity_time = timeAlert;
			this.editAlert.sent = false;

			this._requirements.editAlert(this.idAlert, this.editAlert).subscribe(resp =>{
				if (resp['error']) {
					this.loading = false;
					this._errorNewAlert.next('Error: No se pudo editar la alerta, inténtelo de nuevo.');
				} else {
					this.loading = false;
					this._successNewAlert.next('Se realizo correctamente lo solicitado.');
					setTimeout(() => this.activeModal.dismiss(), 2000);
					setTimeout(() => this.confirmAlert.emit(true), 2000);
				}
			});
			// clear the Object
			this.editAlert = new Alert();
		}
	}
	/*
		Validation Alert
	*/
	validationAlert(): boolean {
		if (this.timeAlert == null) {
			this._errorNewAlert.next('Error: Falta el campo Hora.');
			return false;
		} else {
			//this._successNewAlert.next('Se registro una alerta correctamente!!!');
			return true;
		}
	}

	// Load modules
	loadAlerts() {
		// Getting history activities alerts
		this._requirements.getAllActvAlerts(this.reqId).subscribe(resp => {
			if (resp['error']) {
				throw Error('Service Error');
			} else {
				 let actvAlertHistory = resp['result'];
				 this.findItem(actvAlertHistory);
			}
		});
	}

	findItem(alertActv) {
		// find the activity and the activity's alert
		const activity = alertActv.find( actv => actv.activity.id === this.idActivity);
		/* Activity */
		this.actvName = activity.activity.subject;
		this.dateActv = activity.activity.activity_date.substring(0,10).split('-').reverse().toString().replace(',','/').replace(',','/');
		// insert MaxDate
		this.maxdate = {
			year: Number(activity.activity.activity_date.substring(0, 4)),
			month: Number(activity.activity.activity_date.substring(5, 7)),
			day: Number(activity.activity.activity_date.substring(8, 10)),
		};
		/* Alert */
		const alert = activity.alert.find( alt => alt.id === this.idAlert);
		this.alertName = alert.name;
		this.model1 = {
			year: Number(alert.before_activity_date.substring(0, 4)),
			month: Number(alert.before_activity_date.substring(5, 7)),
			day: Number(alert.before_activity_date.substring(8, 10)),
		};
		this.timeAlert = {
			hour: Number(alert.before_activity_time.substring(0, 2)),
			minute: Number(alert.before_activity_time.substring(3, 5)),
			second: Number(alert.before_activity_time.substring(6, 8))
		};

	}
	// messages
	messageNewAlert() {
		this._successNewAlert.subscribe(message => this.successMessageNewAlert = message);
		this._successNewAlert.pipe (
			debounceTime(2000)
		).subscribe(() => this.successMessageNewAlert = '');
		this._errorNewAlert.subscribe(message => this.errorMessageNewAlert = message);
		this._errorNewAlert.pipe (
				debounceTime(2000)
		).subscribe(() => this.errorMessageNewAlert = '');
	}

}
